import { initCountdown } from '../components/countdown'
import './../../scss/blocks/_countdown.scss'

document.addEventListener('DOMContentLoaded', () => {
    const countdowns = document.querySelectorAll('.countdown')
    countdowns.forEach((countdown) => {
        initCountdown(countdown)
    })
})
